module.exports = function (data) {
    return {
        event: 'BWSlinkClick',
        eventContext: {},
        linkName: data
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/atmmapper/online-buy-gs-mapper.js
 **/